import { Directive, HostBinding } from '@angular/core';

import { A11yRole } from '../interfaces/a11y.interfaces';

@Directive({
  selector: '[khA11yList]'
})
export class A11yListDirective implements A11yRole {
  @HostBinding('attr.role') public readonly role = 'list';
}
